// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
function emptyInfiniteResult_setSize(param) {}
function emptyInfiniteResult_mutate(param, param$1) {
  return Promise.resolve(undefined);
}
var emptyInfiniteResult = {
  data: undefined,
  size: 0,
  setSize: emptyInfiniteResult_setSize,
  isValidating: false,
  error: undefined,
  mutate: emptyInfiniteResult_mutate
};
function makeVirtualInfiniteResult(data) {
  return {
    data: data,
    size: 1,
    setSize: function (param) {},
    isValidating: false,
    error: undefined,
    mutate: function (param, param$1) {
      return Promise.resolve(undefined);
    }
  };
}
function getPageInfo(swrInfiniteResult, getNext, getContents) {
  var data = swrInfiniteResult.data;
  var reachedEnd = Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(data, function (pages) {
    return Belt_Array.get(pages, pages.length - 1 | 0);
  }), function (lastPage) {
    return Curry._1(getNext, lastPage) === undefined;
  }), false);
  var numLoadedPages = Belt_Option.getWithDefault(Belt_Option.map(data, function (prim) {
    return prim.length;
  }), 0);
  var contents = Belt_Option.map(data, function (data) {
    return Belt_Array.concatMany(Belt_Array.map(data, Curry.__1(getContents)));
  });
  var isFetching = data === undefined && swrInfiniteResult.error === undefined;
  return {
    reachedEnd: reachedEnd,
    size: swrInfiniteResult.size,
    numLoadedPages: numLoadedPages,
    setSize: swrInfiniteResult.setSize,
    isFetching: isFetching,
    contents: contents
  };
}
function useRateLimitedPagination(infiniteResult, limit) {
  var totalRequestsMade = React.useRef(1);
  var setSize = infiniteResult.setSize;
  var size = infiniteResult.size;
  var numOfLoadedPages = Belt_Option.getWithDefault(Belt_Option.map(infiniteResult.data, function (prim) {
    return prim.length;
  }), 0);
  var setSize$1 = React.useCallback(function (nextSize) {
    var finishedPreviousRequest = totalRequestsMade.current <= (numOfLoadedPages + limit | 0);
    if (finishedPreviousRequest) {
      totalRequestsMade.current = totalRequestsMade.current + 1 | 0;
      Curry._1(setSize, nextSize);
      return true;
    } else {
      return false;
    }
  }, [limit, size, setSize, numOfLoadedPages]);
  return React.useMemo(function () {
    return {
      size: size,
      setSize: setSize$1
    };
  }, [size, setSize$1]);
}
export { emptyInfiniteResult, makeVirtualInfiniteResult, getPageInfo, useRateLimitedPagination };
/* react Not a pure module */